<template>
  <div class="NavTop">
    <div/>
    <div class="l">
      <el-dropdown @command="handleCommand">
        <div class="usercard el-dropdown-link">
          <el-avatar v-if="currentUser.avatar" :size="40" :src="currentUser.avatar.thumbnail"></el-avatar>
          <el-avatar v-else :size="40" :src="'https://www.floresdevida.org/wp-content/uploads/2018/06/default-user-thumbnail-1.png'"></el-avatar>
          <div>{{currentUser.name}}</div>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="!$can('1')" command="perfil">Meus Dados</el-dropdown-item>
          <el-dropdown-item command="exit">Sair</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
<!-- 
    <el-dialog title="Perfil" :visible.sync="dialogPerfil" @open="clearData">
      <div v-loading="loadingFormUSer">
        <el-form :model="formUser" ref="formUser" :rules="rulesformUser" @submit.prevent="submitPerfil('formUser')" v-on:submit.prevent>
          <el-form-item prop="name" label="Nome">
            <el-input size="large" v-model="formUser.name" required></el-input>
          </el-form-item>
          <el-form-item prop="email" label="Email">
            <el-input size="large" v-model="email"
                      placeholder="example@gmail.com"
                      disabled
                      type="email" required></el-input>
          </el-form-item>
        </el-form>
        <el-card v-if="changePass" shadow="never" class="el-card-danger">
          <el-form v-loading="loadingPassUser" :model="formUserPass" ref="formUserPass" :rules="rulesformUserPass" @submit.prevent="submitRecoverPass('formUserPass')" v-on:submit.prevent>
            <el-form-item prop="current_password" label="Senha Atual" :error="error.current_password">
              <el-input  size="large"
                         placeholder="● ● ● ● ● ●"
                         v-model="formUserPass.current_password"
                         :type="type" required>
                <i class="el-icon-view el-input__icon" slot="suffix" @click="changeType">
                </i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password" label="Nova Senha" :error="error.password">
              <el-input  size="large"
                         placeholder="● ● ● ● ● ●"
                         v-model="formUserPass.password"
                         :type="type" required>
                <i class="el-icon-view el-input__icon" slot="suffix" @click="changeType">
                </i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password_confirmation" label="Confirmar Senha" :error="error.password_confirmation">
              <el-input  size="large"
                         placeholder="● ● ● ● ● ●"
                         v-model="formUserPass.password_confirmation"
                         :type="type" required>
                <i class="el-icon-view el-input__icon" slot="suffix" @click="changeType">
                </i>
              </el-input>
            </el-form-item>
            <el-button type="danger" @click.prevent="submitRecoverPass('formUserPass')">Salvar</el-button>
          </el-form>
        </el-card>
        <br>
        <span slot="footer" class="dialog-footer">
        <div style="display: flex;justify-content: space-between;">
          <el-button plain @click="changePass = !changePass">Alterar Senha</el-button>
        <el-button type="primary" @click.prevent="submitPerfil('formUser')">Salvar</el-button>
        </div>
      </span>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {loadUserData, logout, updatePassword} from "../../../Auth/services";
import {setFormData} from "../../../../plugins/utils";
// import {postProfile} from "../../services";
export default {
  name: "NavTop",
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Por favor insira a senha'));
      } else {
        if (this.formUserPass.confirm_password !== '') {
          this.$refs.formUserPass.validateField('confirm_password');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Por favor insira a senha novamente'));
      } else if (value !== this.formUserPass.password) {
        callback(new Error('As duas senhas tem que serem iguais.'));
      } else {
        callback();
      }
    };
    return {
      changePass: false,
      loadingPassUser: false,
      loadingFormUSer: false,
      dialogPerfil: false,
      type: 'password',
      error: {},
      formUserPass: {
        current_password: '',
        password: '',
        password_confirmation: '',
      },
      formUser: {
        name: '',
      },
      email: '',
      rulesformUserPass: {
        current_password: [
          {required: true, message: 'Por favor informe sua senha atual.', trigger: 'blur'},
        ],
        password: [
          { validator: validatePass, trigger: 'blur' }
        ],
        password_confirmation: [
          { validator: validatePass2, trigger: 'blur' }
        ],
      },
      rulesformUser: {
        name: [
          {required: true, message: 'Por favor informe um Nome', trigger: 'blur'},
        ],
      },
    }
  },
  computed: {
    ...mapGetters('Auth', ['currentUser']),
  },
  methods: {
    clearData () {
      this.changePass = false
      this.type = 'password'
      this.formUserPass = {
        current_password: '',
        password: '',
        password_confirmation: '',
      }
    },
    changeType () {
      if (this.type === 'password') {
        this.type = 'text'
      } else if (this.type === 'text') {
        this.type = 'password'
      }
    },
    async submitRecoverPass (ruleForm){
      this.$refs[ruleForm].validate(async (valid) => {
        if (valid) {
          this.loadingFormUSer = true
          this.$confirm('Deseja realmente alterar sua senha atual?', 'Alterar Senha', {
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            type: 'warning'
          }).then(async () => {
            try {
              let response = await updatePassword(this.formUserPass)
              await this.loadUSER()
              this.$message({
                showClose: true,
                message: response.message,
                type: 'success'
              })
              this.loadingFormUSer = false
              this.dialogPerfil = false
            } catch (e) {
              this.$message({
                showClose: true,
                message: e.body.error.message,
                type: 'error'
              })
              this.loadingFormUSer = false
            }
          }).catch(() => {
            this.loadingFormUSer = false
          });
        }
      })
    },
    async submitPerfil (ruleForm){
      // this.$refs[ruleForm].validate(async (valid) => {
      //   if (valid) {
      //     this.loadingFormUSer = true
      //     try {
      //       let response = await postProfile(setFormData(this.formUser))
      //       await this.loadUSER()
      //       this.$message({
      //         showClose: true,
      //         message: response.message,
      //         type: 'success'
      //       })
      //     } catch (e) {
      //       this.$message({
      //         showClose: true,
      //         message: e.body.error.message,
      //         type: 'error'
      //       })
      //     } finally {
      //       this.loadingFormUSer = false
      //       this.dialogPerfil = false
      //     }
      //   }
      // })
    },
    async loadUSER () {
      try {
        let response = await loadUserData()
        this.$store.commit('Auth/SET_USER', response)
      } catch (e) {
        this.$message({
          showClose: true,
          message: e.body.error.message,
          type: 'error'
        })
      } finally {
        this.loadingFormUSer = false
        this.dialogPerfil = false
      }
    },
    async handleCommand(command) {
      if (command === 'exit') {
        try {
          let response = await logout()
          await this.$router.push({name: 'auth.login'})
          this.$store.commit('Auth/SET_TOKEN', null)
          this.$store.commit('Auth/CLEAN_USER', null)
          this.$message({
            showClose: true,
            message: 'Você saiu do sistema.',
            type: 'success'
          })
        } catch (e) {
          this.$message({
            showClose: true,
            message: e.body.error.message,
            type: 'error'
          })
        }
      } else if (command === 'perfil') {
        // this.dialogPerfil = true
        await this.$router.push({name: 'home.perfil.view'})
      }
    }
  },
  mounted() {
    this.formUser.name = this.currentUser.name
    this.email = this.currentUser.email
  }
}
</script>
